import MarkdownIt from 'markdown-it'
import ins from 'markdown-it-ins'

const md = new MarkdownIt({ linkify: false, typographer: false})

md.use(ins)

md.disable([
  'blockquote', 'code', 'fence', 'heading',
  'hr', 'html_block', 'lheading', 'list',
  'reference', 'table', 'html_inline', 'image', 'backticks'
])

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet('target', '_blank')
  tokens[idx].attrSet('rel', 'nofollow noopener noreferrer')
  return self.renderToken(tokens, idx, options)
}

export const renderMarkdown = (text) => md.renderInline(text || '')